import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;


export const getReferralList = (referralData, showLoader = true) => {
  return async (dispatch) => {
    // if (showLoader) {
    //   dispatch({ type: "START_LOADING" });
    // }
    try {
      dispatch({ type: "GET_REFERRAL_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/referral/list`,
        referralData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_REFERRAL_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_REFERRAL_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_REFERRAL_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const getSignupReferralList = (referralData, showLoader = true) => {
  return async (dispatch) => {
    // if (showLoader) {
    //   dispatch({ type: "START_LOADING" });
    // }
    try {
      dispatch({ type: "GET_USER_REFERRAL_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/referral/user-list`,
        referralData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "GET_USER_REFERRAL_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_USER_REFERRAL_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_USER_REFERRAL_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      if (showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const viewReferral = (referralData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_REFERRAL_REQUEST" });

      const config = {
        headers: { "Content-Type": "application/json" },
      };

      const { data } = await axios.get(
        `${BASE_URL}/referral/view/${referralData._id}`,
        config
      );

      console.log("API Response for viewReferral:", data);

      if (data.statusCode === 200) {
        console.log("Dispatching VIEW_REFERRAL_SUCCESS with:", data.data);
        dispatch({ type: "VIEW_REFERRAL_SUCCESS", payload: data.data });
      } else {
        dispatch({ type: "VIEW_REFERRAL_FAILED", payload: data });
      }
    } catch (error) {
      console.error("Error in viewReferral:", error);
      dispatch({
        type: "VIEW_REFERRAL_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateReferralStatus = (id, status) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      await axios.post(`${BASE_URL}/referral/update`, {
        id,
        status,
      });

      toast.success("Status updated successfully!");

      // After update, fetch the updated referral details again
      dispatch(viewReferral({ _id: id }));
    } catch (error) {
      toast.error("Error updating status");
      console.error("Error updating referral status:", error);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


